type PixelParams = Record<string, string | number | string[]>
type FbqWindow = Window & {
  fbq?: (...args: unknown[]) => void
  __mpFiredPixelEvents?: Record<string, number>
}
const DEDUPE_WINDOW_MS = 1500
function getWindow(): FbqWindow | null {
  return typeof window === 'undefined' ? null : (window as FbqWindow)
}
function getFbq(win: FbqWindow) {
  return typeof win.fbq === 'function' ? win.fbq : null
}
/**
 * Fires a standard Meta event at most once per key.
 * The registry lives on `window`, so React re-renders, remounts or hot
 * reloads cannot fire the same event twice.
 */
export function trackEventOnce(
  event: string,
  params?: PixelParams,
  key = event,
) {
  const win = getWindow()
  if (!win) return
  const registry = win.__mpFiredPixelEvents || (win.__mpFiredPixelEvents = {})
  if (registry[key]) return
  const fbq = getFbq(win)
  if (!fbq) return
  registry[key] = Date.now()
  fbq('track', event, params)
}
/**
 * Fires a standard Meta event, ignoring repeated calls inside a short
 * window (e.g. double clicks or duplicated click handlers on one CTA).
 */
export function trackEventDeduped(
  event: string,
  params?: PixelParams,
  key = event,
) {
  const win = getWindow()
  if (!win) return
  const registry = win.__mpFiredPixelEvents || (win.__mpFiredPixelEvents = {})
  const last = registry[key]
  const now = Date.now()
  if (last && now - last < DEDUPE_WINDOW_MS) return
  const fbq = getFbq(win)
  if (!fbq) return
  registry[key] = now
  fbq('track', event, params)
}
export const ORDEN_FINANCIERO_CONTENT: PixelParams = {
  content_name: 'Orden Financiero',
  content_type: 'product',
  content_ids: ['orden-financiero'],
  value: 9.9,
  currency: 'USD',
}
